var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "myContainer",
      staticClass: "my-container",
      style: _vm.inScreen ? _vm.autoStyle : "",
    },
    [
      _c(
        "div",
        {
          ref: "conditionMain",
          staticClass: "condition-main",
          style: _vm.outsideStyle,
        },
        [
          _vm.element.options.attrs.showTitle && _vm.element.options.attrs.title
            ? _c(
                "div",
                {
                  ref: "deTitleContainer",
                  staticClass: "condition-title",
                  style: _vm.titleStyle,
                },
                [
                  _c("div", { staticClass: "condition-title-absolute" }, [
                    _c("div", { staticClass: "first-title" }, [
                      _c("div", { staticClass: "span-container" }, [
                        _c("span", { ref: "deTitle" }, [
                          _vm._v(_vm._s(_vm.element.options.attrs.title)),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              ref: "deContentContainer",
              staticClass: "condition-content",
              class:
                _vm.element.options.attrs.showTitle &&
                _vm.element.options.attrs.title
                  ? ""
                  : "condition-content-default",
            },
            [
              _c("div", { staticClass: "condition-content-container" }, [
                _c("div", { staticClass: "first-element" }, [
                  _c(
                    "div",
                    {
                      staticClass: "first-element-container",
                      class:
                        _vm.element.component === "de-select-grid"
                          ? "first-element-grid-container"
                          : "",
                      style: _vm.deSelectGridBg,
                    },
                    [
                      _vm.element.type === "custom"
                        ? _c(_vm.element.component, {
                            ref: "deOutWidget",
                            tag: "component",
                            staticClass: "component-custom",
                            attrs: {
                              id: "component" + _vm.element.id,
                              "canvas-id": _vm.canvasId,
                              "out-style": _vm.element.style,
                              "is-relation": _vm.isRelation,
                              element: _vm.element,
                              "in-draw": _vm.inDraw,
                              "in-screen": _vm.inScreen,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }